import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Button, Typography, Grid, useMediaQuery, Link } from '@material-ui/core';

// CONSTANTS
import { ROUTE_SLING_AIR_TV_LANDING } from '@/constants/routes';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';
import { getSubscriptionLink } from '@/utility/subscription';
import { routeEnhance } from '@/utility/routes';

// COMPONENTS
import RouterLink from '@/components/Link';

// STYLES
import { Container } from './styles';

const channelFoxImg = getS3ImageUrl('/logos/channels/color/fox_new_color.png');
const channelCBSImg = getS3ImageUrl('/logos/channels/color/cbs_new_color.png');
const channelNBCImg = getS3ImageUrl('/logos/channels/color/nbc_new_color.png');
const channelABCImg = getS3ImageUrl('/logos/channels/color/abc_new_color.png');

const sling_channels = [
  { name: 'fox', src: channelFoxImg },
  { name: 'cbs', src: channelCBSImg },
  { name: 'nbc', src: channelNBCImg },
  { name: 'abc', src: channelABCImg },
];

const BannerSlingPromo = () => {
  const [t] = useTranslation();
  const upSm = useMediaQuery(({ breakpoints }) => breakpoints.up('sm'));

  const price = '20';
  const oldPrice = '40';
  const subscriptionLink = `${getSubscriptionLink('sling-tv')}?spec-offer=yes`;
  const slingAirTVLink = routeEnhance(ROUTE_SLING_AIR_TV_LANDING);
  const logo = getS3ImageUrl('/banners/sling-logo.png');
  const channels = sling_channels;

  const benefits = [
    { title: t('swimlanes.sling-airtv.benefits.item1') },
    { title: t('swimlanes.sling-airtv.benefits.item2') },
    { title: t('swimlanes.sling-airtv.benefits.item3') },
  ];

  return (
    <Container className="banner-app">
      <Grid container spacing={3} direction={upSm ? 'row' : 'column'}>
        <Grid item xs={12} sm={6} md={7}>
          <Typography className="banner-app__title" variant="h3">
            <Trans
              i18nKey="swimlanes.sling-airtv.title"
              components={{
                img: <img alt="logo" src={logo} />,
                a: <Link to={slingAirTVLink} target="_blank" component={RouterLink} />,
              }}
            />
          </Typography>
          <ul className="pros-cons-list pros-cons-list--square-icons">
            {benefits.map((benefit, idx) => (
              <li className="pcl-item" key={idx}>
                <i className="icon-check" />
                {benefit.title}
              </li>
            ))}
          </ul>
          <div className="channels">
            {channels.map(({ src, name }, i) => (
              <div className="channels__item" key={i}>
                <img className="channels__icon" src={src} alt={name} />
              </div>
            ))}
          </div>
          <Button
            className="banner-app__btn sizeExtraLarge"
            color="primary"
            to={subscriptionLink}
            component={RouterLink}
          >
            {t('buttons.getSlingNow')}
          </Button>
        </Grid>
        <Grid className="banner-app__section-right" item xs={12} sm={6} md={5}>
          <img
            className="banner-app__channels-img"
            src={getS3ImageUrl('/banners/banner-sling-channels.png')}
            alt="sling-channels"
          />
          <div className="banner-app__price">
            <img src={getS3ImageUrl('/banners/banner-discount-label.png')} alt="disc-label" />
            <div className="price">
              <Typography className="price__text p3">
                {t('swimlanes.sling-airtv.discountText')}
              </Typography>
              <div className="price__block">
                <Typography className="price__old-price">
                  <strike>{t('common.costMo', { cost: oldPrice })}</strike>
                </Typography>
                <Typography className="price__new-price" variant="h5">
                  {t('common.costMo', { cost: price })}
                </Typography>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default React.memo(BannerSlingPromo);
